var React = require('react');

function Remove (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.25 3.25V3C4.25 1.48122 5.48122 0.25 7 0.25H9C10.5188 0.25 11.75 1.48122 11.75 3V3.25H15C15.4142 3.25 15.75 3.58579 15.75 4C15.75 4.41421 15.4142 4.75 15 4.75H13.75V13C13.75 14.5188 12.5188 15.75 11 15.75H5C3.48122 15.75 2.25 14.5188 2.25 13V4.75H1C0.585786 4.75 0.25 4.41421 0.25 4C0.25 3.58579 0.585786 3.25 1 3.25H4.25ZM5.75 3C5.75 2.30964 6.30964 1.75 7 1.75H9C9.69036 1.75 10.25 2.30964 10.25 3V3.25H5.75V3ZM3.75 4.75H12.25V13C12.25 13.6904 11.6904 14.25 11 14.25H5C4.30964 14.25 3.75 13.6904 3.75 13V4.75Z","fill":"#181818"}));
}

Remove.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Remove;

Remove.default = Remove;
